import { SeasonDto, SeasonSchema, SeasonsListResponse, SeasonsListResponseSchema } from '@/types/season';
import { apiRequest } from './client';

const SEASONS_BASE = '/api/v1/seasons';

export interface GetSeasonsParams {
  is_current?: boolean;
  order?: 'start_year.desc' | 'start_year.asc' | 'created_at.desc' | 'created_at.asc';
  limit?: number;
  offset?: number;
}

export async function getSeasons(params: GetSeasonsParams = {}): Promise<SeasonsListResponse> {
  const query = new URLSearchParams();
  if (params.is_current !== undefined) query.set('is_current', String(params.is_current));
  if (params.order) query.set('order', params.order);
  if (params.limit !== undefined) query.set('limit', String(params.limit));
  if (params.offset !== undefined) query.set('offset', String(params.offset));

  const qs = query.toString();
  const url = `${SEASONS_BASE}${qs ? `?${qs}` : ''}`;

  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return SeasonsListResponseSchema.parse(res);
}

export async function getCurrentSeason(): Promise<SeasonDto> {
  const res = await apiRequest<unknown>({ url: `${SEASONS_BASE}/current`, method: 'GET' });
  return SeasonSchema.parse(res);
}

